/**
 * Cookie Consent Modal Hook
 * Manages state and logic for the cookie consent modal
 */

import { useCallback } from "react";
import {
  denyCookieConsent,
  grantCookieConsent,
} from "../../helpers/cookie-consent/cookie-consent.helper";

interface UseCookieConsentModalProps {
  onClose: () => void;
}

interface UseCookieConsentModalReturn {
  handleAccept: () => void;
  handleDecline: () => void;
}

export const useCookieConsentModal = ({
  onClose,
}: UseCookieConsentModalProps): UseCookieConsentModalReturn => {
  const handleAccept = useCallback(() => {
    grantCookieConsent();
    onClose();
  }, [onClose]);

  const handleDecline = useCallback(() => {
    denyCookieConsent();
    onClose();
  }, [onClose]);

  return {
    handleAccept,
    handleDecline,
  };
};
